import React from 'react'
import PropTypes from 'prop-types'

function PDFRenderer({ pdf, title }) {
  const dataEvent = `${title} Manual Download`
  const instruction = `Download ${title} PDF`
  const fullUrl = `http:${pdf}`
  return (
    <div style={{ background: '#000', width: '100vw', height: '100vh' }}>
      <iframe
        title="gdocsviewer"
        src={`https://docs.google.com/viewer?url=${encodeURIComponent(fullUrl)}&embedded=true`}
        width="100%"
        height="100%"
        frameBorder="0"
      >
        <a
          className="button"
          href={fullUrl}
          data-event={dataEvent}
          target="_blank"
          rel="noopener noreferrer"
        >
          {instruction}
        </a>
      </iframe>
    </div>
  )
}

PDFRenderer.propTypes = {
  pdf: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}

export default PDFRenderer
